// extracted by mini-css-extract-plugin
module.exports = {"title":"BasePageIntro-title-xt-i9ffh_R","container":"BasePageIntro-container-3i_Ng9j3jR"};